export const statisticProcesses: TableModule = {
    name: "statisticProcesses",
    route: "spa.statistics.statisticProcesses",
    columns: [
        {
            name: "serial_number",
            sortable: true,
            width: 'w-24',
        }, {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "organisation",
            sortable: true,
            sortBy: "organisations.name",
            breakpoint: "lg"
        }, {
            name: "statisticSurvey",
            sortable: true,
            sortBy: "statistic_surveys.name",
        }, {
            name: "statisticSurveyPeriod",
            sortable: true,
            sortBy: "statistic_survey_periods.start_date",
            hidden: true,
        }, {
            name: "statisticForm",
            breakpoint: "xl"
        }, {
            name: "processes",
            breakpoint: "xl",
            sortable: true,
            sortBy: "customOrderProcesses",
        }, {
            name: "status",
            sortable: true,
            sortBy: "status_id",
            width: 'w-[120px]',
        }
    ],
    filters: [
        {
            name: "organisation",
            column: "statistic_processes.organisation_id",
            type: "searchSelect",
            apiRoute: "spa.settings.organisations.index",
            reduced: 'in',
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
        }, {
            name: "statisticForm",
            column: "statistic_processes.statistic_formable_id",
            type: "searchSelect",
            apiRoute: "spa.statistics.statisticForms.index",
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
            }
        }, {
            name: "statisticSurvey",
            column: "customFilterStatisticSurvey",
            type: "searchSelect",
            apiRoute: "spa.statistics.statisticSurveys.index",
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
            }
        }, {
            name: "statusKey",
            column: "statuses.key",
            type: "select",
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.statistics.statisticProcesses.statuses.index')
            ).then(response => response.data?.map(
                status => ({
                    value: status.key,
                    label: status.name_management_area
                }))
            ),
            reduced: true,
            multiple: true
        }, {
            name: "association",
            column: "organisations.association_id",
            relation: "organisation",
            type: "searchSelect",
            apiRoute: "spa.settings.organisations.index",
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
            searchSelectConfig: {
                filter: [{
                    column: "type",
                    operator: "=",
                    value: "association"
                }]
            },
            reduced: false,
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "statisticProcesses.changeStatus",
            icon: "heroicons:chart-bar-square",
        }, {
            name: "statisticProcesses.transfer",
            icon: "heroicons:paper-airplane",
            ability: ["transfer", "statisticProcesses"]
        }, {
            name: "general.export",
            icon: "heroicons:arrow-down-tray"
        }
    ]
}